import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"

// Filtre client de la grille d'administration des juniors.
// Chaque carte porte data-search (texte normalisé : nom, code JE, slug, code membre).
export default class extends Controller {
  static targets = ["search", "card", "count", "empty"]

  filter() {
    const matcher = makeMatcher(this.searchTarget.value)
    let visible = 0

    this.cardTargets.forEach((card) => {
      const show = matcher(card.dataset.search || "")
      card.hidden = !show
      if (show) visible += 1
    })

    if (this.hasCountTarget) this.countTarget.textContent = visible
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible !== 0
  }
}
